module.exports = require("@material-ui/icons/ArrowBack");